

//请求乐高基础数据
export const HOME_REQ_BASE = 'HOME_REQ_BASE'
//处理乐高基础数据
export const HOME_HANDLE_BASE = 'HOME_HANDLE_BASE'
//请求任务详情
export const HOME_DETAIL = 'HOME_DETAIL'
//处理任务详情
export const HOME_HANDLE = 'HOME_HANDLE'

//领取奖励
export const HOME_REWARD = 'HOME_REWARD'
//处理领取奖励
export const HOME_HANDLE_REWARD = 'HOME_HANDLE_REWARD'

//领取任务
export const HOME_REC_TASK = 'HOME_REC_TASK'
//处理任务
export const HOME_HANDLE_TASK = 'HOME_HANDLE_TASK'


